import { Trans, useTranslation } from 'react-i18next';
import Breadcrumb from '../../../components/common/Breadcrumb/Breadcrumb';
import ButtonPrimaryMedium from '../../../components/common/ButtonPrimary/ButtonPrimaryMedium';
import { Icon } from '../../../components/icon/icon';
import HeaderCMS from '../../../components/layout/HeaderCMS/HeaderCMS';
import SearchComponent from '../../../components/common/SearchComponent/SearchComponent';
import SelectComponent from '../../../components/common/SelectComponent/SelectComponent';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect } from 'react';
import {
  fetchOrderAdmin,
  fetchOrdersAdmin,
  fetchStatMonthly,
  updateOrderAdmin,
} from '../../../store/actions/admin.room.action';
import ROUTER from '../../../routers/Routers';
import { useNavigate } from 'react-router-dom';
import formatDateTime from '../../../utils/dayjs/formatDateTime.util';
import RenderFulfillmentHistoryStatusTag from '../../../components/common/Tag/RenderFulfillmentHistoryStatus';
import { useSearchParams } from 'react-router-dom';
import {
  AMOUNT_OPTIONS,
  PRODUCT_OPTIONS,
  STATUS_OPTIONS,
} from '../../../constants/constant';
import { reloadAdminOrders } from '../../../store/reducers/admin.room.reducer';
import ButtonIconOutlineMedium from '../../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import { createStyles } from 'antd-style';
import ButtonTertiaryMedium from '../../../components/common/ButtonTertiary/ButtonTertiaryMedium';
import Tag from '../../../components/common/Tag/Tag';
import { openMessageSuccess } from '../../../components/common/Message/openMessageSuccess';
import { Pagination } from 'antd';
import RenderRefundStatus from '../../../components/common/Tag/RenderRefundStatus';
import openModalRefundInformation from '../../../components/common/Modal/openModalRefundInformation';
import ButtonSecondarySmall from '../../../components/common/ButtonSecondary/ButtonSecondarySmall';
import { Avatar } from 'antd';
import { getValueFromString } from '../../../utils/data/getValue.utils';
import { convertForeignCurrency } from '../../../utils/currency/currency.utils';

const useStyle = createStyles(({ css }) => ({
  customTable: css`
    .ant-table-container {
      .ant-table-body,
      .ant-table-content {
        scrollbar-width: thin;
        scrollbar-color: #eaeaea transparent;
        scrollbar-gutter: stable;
        table {
          thead {
            tr {
              th:first-child {
                border-top-left-radius: 8px;
                border-bottom-left-radius: 8px;
              }
              th:last-child {
                border-top-right-radius: 8px;
                border-bottom-right-radius: 8px;
              }
              th {
                border: none;
              }
            }
          }
          tbody {
            tr {
              padding: 8px 0;
              td {
                border: none;
              }
            }
          }
        }
      }
    }
  `,
}));

const STATUS_ORDER_OPTIONS = [
  'Create order',
  'Confirm order',
  'Board manufacturing',
  'Furniture manufacturing',
  'Transport',
  'Delivery',
  'Construction & Installation',
  'Completed',
  'Order cancelled',
];

const SalesPage = () => {
  const styleResult = useStyle();
  const { t } = useTranslation();

  const { order, statMonthly } = useSelector(state => state.adminRoom);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { styles } = useStyle();

  const [searchParams, setSearchParams] = useSearchParams();
  const kwParam = searchParams.get('kw') || '';
  const statusParam = searchParams.get('status') || '';
  const amountParam = searchParams.get('amount') || '';
  const productParam = searchParams.get('product') || '';
  const offsetParam = searchParams.get('offset') || '0';
  const limitParam = searchParams.get('limit') || '10';

  const updateSearchParams = (key, value) => {
    // Sử dụng searchParams.entries() để lấy các cặp key-value
    const params = Object.fromEntries(searchParams);
    if (value !== null && value !== undefined && value !== '') {
      params[key] = value;
      setSearchParams(params);
      if (key !== 'offset') {
        setSearchParams({ ...params, [key]: value, offset: 0 });
      }
    } else {
      delete params[key];
      setSearchParams(params);
    }
  };

  const renderProjectItems = items => {
    return items?.map((item, index) => {
      const total =
        (item.total_accessory_price ?? 0) +
        (item.total_backsplash_price ?? 0) +
        (item.total_countertop_price ?? 0) +
        (item.total_wood_price ?? 0);
      return (
        <div key={index} className="flex items-center self-stretch gap-[8px]">
          <div className="flex items-center grow gap-[24px]">
            <div
              className={`aspect-square w-[60px] h-[60px] rounded-[4px] opacity-60 `}
              style={{
                backgroundImage: `url(${item.thumbnail})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            />
            <span className="text-body-large font-semibold">
              {getValueFromString(item.item_name)}
            </span>
          </div>
          <div className="flex flex-col justify-center items-start w-[250px] gap-[8px]">
            <TagFittaInstallation />
          </div>
          <div className="flex flex-col justify-center items-start w-[40px] gap-[8px]">
            <span className="text-body-medium">x1</span>
          </div>
          <div className="flex flex-col justify-center items-start w-[112px] gap-[8px]">
            <span className="text-body-medium">
              {convertForeignCurrency(total)}
            </span>
          </div>
        </div>
      );
    });
  };

  const loadOrders = useCallback(() => {
    dispatch(
      fetchOrdersAdmin({
        offset: offsetParam ?? 0,
        limit: limitParam ?? 10,
        fulfillment_status: statusParam?.length ? Number(statusParam) : null,
        kw: kwParam?.length ? kwParam : null,
        amount: amountParam?.length ? Number(amountParam) : null,
        product_name: productParam?.length ? productParam : null,
      })
    );
  }, [
    kwParam,
    statusParam,
    amountParam,
    productParam,
    offsetParam,
    limitParam,
  ]);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(reloadAdminOrders());
    }, 500); // Đợi 500ms sau khi user ngừng gõ

    // Cleanup: Clear timer nếu user gõ tiếp
    return () => clearTimeout(timer);
  }, [kwParam]);

  useEffect(() => {
    if (order.isNeedReloadData) {
      // Dispatch fetch orders action here
      loadOrders();
    }
  }, [order]);

  useEffect(() => {
    if (statMonthly.isNeedReloadData) {
      dispatch(fetchStatMonthly());
    }
  }, [statMonthly]);

  return (
    <>
      {/* <HeaderCMS
        breadcrumb={
          <Breadcrumb
            items={[
              {
                title: (
                  <span className="text-label-large font-semibold">
                    {t('All orders')}
                  </span>
                ),
              },
            ]}
          />
        }
        // actions={
        //   <ButtonPrimaryMedium
        //     title={t('Create order')}
        //     posIcon={<Icon.ICAddCircle />}
        //   />
        // }
      /> */}
      <section className="flex flex-col p-[16px] items-center justify-center gap-[16px] grow self-stretch h-full">
        <div className="flex flex-col items-start self-stretch rounded-[16px] bg-fills-white grow overflow-auto w-full mx-auto">
          <div className="flex p-[16px] items-center gap-[16px] self-stretch">
            <div className="flex items-center gap-[8px]">
              <SearchComponent
                placeholder={t('Search')}
                size="small"
                value={kwParam}
                setValue={value => {
                  updateSearchParams('kw', value);
                }}
              />
              <SelectComponent
                showSearch={true}
                placeholder={t('Status')}
                size="middle"
                allowClear
                value={
                  statusParam?.length
                    ? [
                        ...STATUS_ORDER_OPTIONS.map((status, index) => ({
                          label: t(status),
                          value: index,
                        })),
                      ].find(item => item.value?.toString() === statusParam)
                    : undefined
                }
                onChange={value => {
                  if (statusParam !== value) {
                    updateSearchParams('status', value);
                  }
                  dispatch(reloadAdminOrders());
                }}
                options={[
                  { label: t('All'), value: null },
                  ...STATUS_ORDER_OPTIONS.map((status, index) => ({
                    label: t(status),
                    value: index,
                  })),
                ]}
              />
              <SelectComponent
                placeholder={t('Product')}
                size="middle"
                showSearch={true}
                allowClear
                value={
                  productParam?.length
                    ? [
                        ...PRODUCT_OPTIONS.map((product, index) => ({
                          label: t(product),
                          value: product,
                        })),
                      ].find(item => item.value?.toString() === productParam)
                    : undefined
                }
                onChange={value => {
                  if (productParam !== value) {
                    updateSearchParams('product', value);
                  } else {
                    updateSearchParams('product', null);
                  }

                  dispatch(reloadAdminOrders());
                }}
                options={[
                  ...PRODUCT_OPTIONS.map((product, index) => ({
                    label: t(product),
                    value: product,
                  })),
                ]}
              />
              <SelectComponent
                placeholder={t('Amount')}
                size="middle"
                showSearch={true}
                allowClear
                value={
                  amountParam?.length
                    ? [
                        ...AMOUNT_OPTIONS.map((amount, index) => ({
                          label: t(amount),
                          value: index,
                        })),
                      ].find(item => item.value?.toString() === amountParam)
                    : null
                }
                onChange={value => {
                  if (amountParam !== value) {
                    updateSearchParams('amount', value);
                  } else {
                    updateSearchParams('amount', null);
                  }

                  dispatch(reloadAdminOrders());
                }}
                options={[
                  ...AMOUNT_OPTIONS.map((amount, index) => ({
                    label: t(amount),
                    value: index,
                  })),
                ]}
              />
            </div>
          </div>
          {/* Table component here */}
          <div className="flex ps-[16px] pe-[8px] flex-col items-start self-stretch grow overflow-hidden relative">
            <div className="flex self-stretch items-center rounded-[8px] bg-[#F7F7F7] mx-[16px] left-0 right-0 absolute">
              <div className="flex py-[10px] ps-[16px] pe-[24px] items-center grow self-stretch">
                <span className="text-body-medium font-semibold">
                  {t('Order ID')}
                </span>
              </div>
              <div className="flex py-[10px] ps-[16px] pe-[24px] w-[160px] items-center flex-shrink-0 self-stretch">
                <span className="text-body-medium font-semibold">
                  {t('Total order')}
                </span>
              </div>
              <div className="flex py-[10px] ps-[16px] pe-[24px] w-[160px] items-center flex-shrink-0 self-stretch">
                <span className="text-body-medium font-semibold">
                  {t('Status')}
                </span>
              </div>
              <div className="flex py-[10px] ps-[16px] pe-[24px] w-[160px] items-center flex-shrink-0 self-stretch">
                <span className="text-body-medium font-semibold">
                  {t('Delivery')}
                </span>
              </div>
              <div className="flex py-[10px] ps-[16px] pe-[24px] w-[200px] items-center flex-shrink-0 self-stretch">
                <span className="text-body-medium font-semibold">
                  {t('Actions')}
                </span>
              </div>
            </div>
            <div className="flex self-stretch items-start gap-[16px] flex-col grow overflow-auto pe-[4px] pt-[10px] mt-[30px] mb-[46px] pb-[10px]">
              {order.data?.map(item => {
                return (
                  <div
                    key={item.id}
                    onClick={() => {
                      if (item?.id)
                        navigate(ROUTER.CMS + ROUTER.ORDER + '/' + item.id);
                    }}
                    className="flex flex-col my-[8px] cursor-pointer self-stretch items-start rounded-[16px] border-[1px] border-solid bg-fills-white"
                  >
                    <div className="flex py-[12px] px-[24px] items-center gap-[16px] self-stretch">
                      <span className="text-title-small !font-bold">
                        {item.code}
                      </span>
                      <div className="flex items-center gap-[6px] rounded-[4px]">
                        <span className="flex w-[24px] h-[24px] justify-center items-center border-[1px] border-solid border-black/10 rounded-[1000px] overflow-hidden">
                          <Avatar
                            src={item.user_avatar}
                            alt={item.name_owner}
                            icon={<Icon.ICAvatar />}
                          />
                        </span>
                        <span className="text-body-small truncate">
                          {item.name_owner}
                        </span>
                      </div>
                    </div>
                    {item.fulfillment_status === 0 && (
                      <div className="flex p-[8px] items-center gap-[8px] self-stretch bg-[#FFF8ED] h-[40px]">
                        <span className="w-[20px] h-[20px] flex justify-center items-center text-[#F97D16]">
                          <Icon.ICInfo />
                        </span>
                        <span className="text-label-large font-semibold">
                          {t('Confirm order')}
                        </span>
                        <span className="text-body-small grow">
                          <Trans
                            i18nKey="Please confirm the order before x. Orders will be cancelled after the deadline."
                            values={{ x: 'Truyền từ API' }}
                          />
                        </span>
                        <ButtonSecondarySmall
                          title={t('Confirm order')}
                          onClick={e => {
                            e.stopPropagation();
                            const data = { id: item.id };
                            data.fulfillment_status = 1;

                            dispatch(updateOrderAdmin(data)).then(action => {
                              if (action.payload?.data) {
                                openMessageSuccess({
                                  content: t('Successfully'),
                                });
                              }
                            });
                          }}
                        />
                      </div>
                    )}

                    <div className="flex items-center self-stretch">
                      <div className="flex p-[16px] pe-[24px] flex-col items-start gap-[16px] grow">
                        {renderProjectItems(item.items)}
                      </div>
                      <div className="flex w-[160px] p-[16px] pe-[24px] flex-col items-start gap-[6px] self-stretch">
                        <span className="text-body-medium font-semibold">
                          {convertForeignCurrency(item.amount)}
                        </span>
                        <Tag
                          label={
                            <span className="text-label-small text-white">
                              {t(
                                item.type === 1
                                  ? 'Pay for the entire order'
                                  : 'Progress payment'
                              )}
                            </span>
                          }
                          className={
                            'flex py-[1px] px-[4px] justify-center items-center rounded-[1000px] bg-[#258FD2]'
                          }
                        />
                        <span className="text-body-small text-black/60">
                          {t(
                            item.paid_step === 1
                              ? 'Paid first time'
                              : item.paid_step === 2
                                ? 'Paid second time'
                                : item.paid_step === 3
                                  ? 'Fully paid'
                                  : ''
                          )}
                        </span>
                      </div>
                      <div className="flex w-[160px] p-[16px] pe-[24px] flex-col items-start gap-[6px] self-stretch">
                        {item.fulfillment_status === 8 ? (
                          <RenderRefundStatus
                            status={(() => {
                              if (
                                (!item.refund_transactions?.length ||
                                  item.refund_transactions?.some(
                                    item => item.status === 0
                                  )) &&
                                item.payment_transactions?.length
                              )
                                return 0;
                              else return 1;
                            })()}
                          />
                        ) : (
                          <RenderFulfillmentHistoryStatusTag
                            orderType={item.type}
                            status={(() => {
                              const listStatus = [0, 1];
                              item.timeline?.forEach((item, index) => {
                                if (item) {
                                  listStatus.push(index + 2);
                                }
                              });
                              const len =
                                item.fulfillment_history_status?.length;
                              const status =
                                item.fulfillment_history_status?.[
                                  len - 1
                                ]?.[0] + 1;
                              // const indexStatus = listStatus.findIndex(
                              //   item => item === status
                              // );

                              return status;
                            })()}
                          />
                        )}
                      </div>
                      <div className="flex w-[160px] p-[16px] pe-[24px] flex-col items-start gap-[6px] self-stretch">
                        <div className="flex flex-col gap-[0px]">
                          <span className="text-body-small text-black/60">
                            {t('Expected delivery date')}:
                          </span>
                          <span className="text-body-small text-black/60">
                            {formatDateTime(
                              item.estimated_delivery_date,
                              'dateFormat.date'
                            )}
                          </span>
                        </div>
                      </div>
                      <div className="flex w-[200px] p-[16px] pe-[24px] flex-col items-start gap-[6px] self-stretch">
                        <ButtonTertiaryMedium title={t('Print invoices')} />
                        {item.fulfillment_status === 4 &&
                          item.fulfillment_status !== 8 && (
                            <ButtonTertiaryMedium
                              title={t('Create shipment')}
                            />
                          )}
                        {item.fulfillment_status === 8 && (
                          <ButtonTertiaryMedium
                            title={t('Update refund')}
                            onClick={e => {
                              e.stopPropagation();
                              dispatch(fetchOrderAdmin({ id: item.id })).then(
                                action => {
                                  if (action.payload?.data) {
                                    openModalRefundInformation({
                                      onClose: () => {
                                        loadOrders();
                                      },
                                    });
                                  }
                                }
                              );
                            }}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
            <div className="flex py-[12px] justify-between items-center self-stretch rounded-[8px] absolute left-0 right-0 bottom-0 mx-[16px] bg-white">
              <Pagination
                // onShowSizeChange={onShowSizeChange}
                className="custom-pagination flex grow [&_.ant-pagination-item-active_a]:!text-white-high"
                current={offsetParam / (limitParam ?? 10) + 1}
                pageSize={limitParam ?? 10} // items per page
                total={order.total ?? 0} // total items
                showSizeChanger={{
                  placement: 'bottomRight',
                  suffixIcon: <Icon.ICExpandMore />,
                  options: [
                    ...[5, 10, 15].map(item => ({
                      label: (
                        <span className="text-body-medium font-semibold !text-black/80">
                          {t('Show') + ' ' + item}
                        </span>
                      ),
                      value: item,
                    })),
                  ],
                }} // allow changing page size
                showTotal={(total, range) => (
                  <span className="text-body-medium text-black/60">
                    {t('Total') + ' item: ' + total}
                  </span>
                )}
                pageSizeOptions={[5, 10, 15, 20]}
                position={['bottomCenter']}
                onChange={(page, pageSize) => {
                  // handle page change
                  updateSearchParams('offset', (page - 1) * pageSize);
                  if (limitParam !== pageSize)
                    updateSearchParams('limit', pageSize);
                  setTimeout(() => {
                    dispatch(reloadAdminOrders());
                  }, 100);
                }}
                prevIcon={
                  <ButtonIconOutlineMedium
                    className="rounded-[4px] ms-auto"
                    icon={<Icon.ICPrev />}
                  />
                }
                nextIcon={
                  <ButtonIconOutlineMedium
                    className="rounded-[4px]"
                    icon={<Icon.ICNext />}
                  />
                }
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SalesPage;

const WidgetStatictis = ({ title, number, percent, icon, iconColor }) => {
  const { t } = useTranslation();

  const renderStatusIcon = () => {
    const percentValue = Number(percent.replace('%', ''));
    if (percentValue > 0) {
      return (
        <div className="flex items-center gap-[4px] text-[#49AC3E]">
          <span className="text-label-medium">{percentValue}%</span>
        </div>
      );
    } else if (percentValue < 0) {
      return (
        <div className="flex items-center gap-[4px] text-[#E5654E]">
          <span className="text-label-medium">{percentValue}%</span>
        </div>
      );
    } else {
      return (
        <div className="flex items-center gap-[4px] text-[#F97D16]">
          <span className="text-label-medium">{percentValue}%</span>
        </div>
      );
    }
  };
  return (
    <div className="flex p-[16px] justify-between items-start grow rounded-[16px] bg-fills-white">
      <div className="flex flex-col justify-center items-start gap-[6px] text-black/60">
        <span className="text-label-large font-semibold">{t(title)}</span>
        <span className="text-title-large !font-bold">{number}</span>
        <div className="flex items-center gap-[16px]">
          {renderStatusIcon()}
          <span className="text-body-small text-black/30">
            {t('Compared to last month')}
          </span>
        </div>
      </div>
      <div
        className={`flex p-[8px] items-center gap-[8px] rounded-[8px]`}
        style={{ background: iconColor }}
      >
        <span className="flex w-[20px] h-[20px] text-white">{icon}</span>
      </div>
    </div>
  );
};
